function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
  fill: "current",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M454 422 c0 -9 -1 -43 -2 -74 l-2 -58 -220 0 c-213 0 -220 -1 -220 -20 0 -11 0 -23 -1 -27 0 -5 14 -11 30 -14 21 -4 31 -3 31 6 0 6 9 20 20 30 17 15 24 16 45 7 14 -6 25 -20 25 -29 0 -15 4 -14 21 7 17 21 19 22 10 3 -6 -12 -8 -28 -5 -37 12 -31 58 -29 68 2 5 15 20 16 131 12 87 -3 125 -2 125 6 0 6 9 19 20 29 17 15 24 16 45 7 14 -6 25 -18 25 -27 0 -8 8 -15 19 -15 16 0 18 6 14 48 -3 26 -15 65 -27 87 -21 38 -23 40 -71 40 l-50 0 -6 -55 -6 -55 -1 67 c-1 37 -6 69 -10 72 -5 3 -8 -3 -8 -12z m53 -69 c-3 -10 -5 -2 -5 17 0 19 2 27 5 18 2 -10 2 -26 0 -35z m86 17 l18 -30 -45 0 c-44 0 -46 1 -46 30 0 26 4 30 28 30 20 0 32 -8 45 -30z m-355 -137 c-2 -10 -10 -18 -18 -18 -8 0 -16 8 -18 18 -2 12 3 17 18 17 15 0 20 -5 18 -17z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 310 c0 -6 80 -10 220 -10 140 0 220 4 220 10 0 6 -80 10 -220 10 -140 0 -220 -4 -220 -10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92 258 c-18 -18 -14 -46 9 -58 26 -14 49 3 49 35 0 32 -35 46 -58 23z m43 -28 c0 -8 -8 -16 -17 -18 -13 -2 -18 3 -18 18 0 15 5 20 18 18 9 -2 17 -10 17 -18z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M532 258 c-18 -18 -14 -46 9 -58 26 -14 49 3 49 35 0 32 -35 46 -58 23z m43 -28 c0 -8 -8 -16 -17 -18 -13 -2 -18 3 -18 18 0 15 5 20 18 18 9 -2 17 -10 17 -18z"
}));

var SvgVehicle3 = function SvgVehicle3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVehicle3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle3.3ed9564d.svg";
export { ForwardRef as ReactComponent };